import { render, staticRenderFns } from "./cbdoil.vue?vue&type=template&id=72311ea9&"
import script from "./cbdoil.vue?vue&type=script&lang=js&"
export * from "./cbdoil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports